module.exports = __webpack_public_path__ + "08b0f3bb9ff6d3e2f7143e5d825770b7.MP3";